import { Controller } from 'react-hook-form';

import { SelectInput, type SelectOption } from './SelectInput';

type Props = {
  name: string;
  options: SelectOption[];
};

export default function ControlledSelectInput({ name, options }: Props): React.ReactElement {
  return (
    <Controller
      name={name}
      render={({ field: { onChange, value } }) => (
        <SelectInput
          name={name}
          onChange={onChange}
          selected={options.find((option) => option.value === value)}
          options={options}
        />
      )}
    />
  );
}
